import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const CloudDownloadIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='-1 -1 18 14'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.64696 4.52457C3.97621 3.02838 4.95029 1.77013 6.29195 1.13388C8.59084 0.0428241 11.283 1.05925 12.4118 3.40352C14.4011 3.4496 16 5.16129 16 7.2665C16 9.40067 14.3568 11.1304 12.3294 11.1304L3.07971 11.1303C2.82303 11.1233 2.56785 11.0836 2.31764 11.0118C0.636987 10.523 -0.349133 8.69335 0.114502 6.92393C0.546544 5.27773 2.08184 4.26415 3.64696 4.52457ZM3.08954 10.4289H12.3306C13.9898 10.4289 15.3345 9.01335 15.3345 7.26675C15.3345 5.52015 13.9898 4.10458 12.3306 4.10458H12.2026C12.0716 4.10458 11.9527 4.02375 11.8988 3.898C10.9831 1.76153 8.59654 0.810716 6.56702 1.77393C5.32336 2.36371 4.44781 3.57636 4.2403 4.99654C4.20997 5.20411 4.01439 5.33734 3.82209 5.28141C2.49643 4.89587 1.12459 5.71517 0.758277 7.11092C0.392551 8.50668 1.17045 9.95001 2.49518 10.3353C2.69292 10.392 2.89509 10.4235 3.08954 10.4289Z'
      />
      <path d='M8.66797 8.47144L11.418 5.21902C11.5398 5.07497 11.7505 5.06123 11.8885 5.18832C12.0265 5.31541 12.0397 5.53521 11.9179 5.67926L8.58459 9.62152C8.45455 9.77532 8.22586 9.77891 8.09144 9.62928L4.75811 5.91867C4.63221 5.77852 4.63903 5.5584 4.77334 5.42703C4.90765 5.29565 5.11859 5.30276 5.2445 5.44292L8.0013 8.51174L8.0013 1.04358C8.33464 1.04358 8.33464 1.04358 8.33464 1.04358L8.66797 1.04358L8.66797 8.47144Z' />
    </svg>
  );
};
